import React, { useEffect } from 'react'
import styles from './browseCat.module.css'
import { useNavigate } from 'react-router-dom';

const BrowseCat = ({topCategories}) => {
   const navigate = useNavigate()


  

    return (
        <div className={styles.browseContainer}>
            <div className={styles.browseRow1}>
                <span>Browse Category</span>
                <p onClick={() => navigate('/categories')} style={{ cursor: 'pointer' }}>SEE MORE</p>
            </div>
            <div className={styles.browseRow2}>
                <div className={styles.regRow}>

                    {topCategories?.map((category) => {
                        return (
                            <div className={styles.regCol} onClick={()=>navigate(`/subcategories/${category?._id}`)} style={{cursor:'pointer'}}>
                                <img src={category?.thumbnail?.photo[0]} style={{width:80,height:80}}/>

                                <span>{category?.name}</span>
                            </div>
                        )

                    })

                    }


                </div>

            </div>
        </div>
    )
}

export default BrowseCat